// extracted by mini-css-extract-plugin
export default {"root":"jCreuVZYn6","description":"Yze0gtY9X0"};